import { createContext, useContext } from "react";

export const SlideContext = createContext({
  idx: 0,
  total: 1,
  label: "",
  tag: "",
});

export const useSlideContext = () => useContext(SlideContext);
